<template>
  <div id="main" class="container">
    <div class="row">
      <div class="col">
        <h1>Bem vindo a nossa integração de conta para desenvolvedores</h1>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>
          As chaves de API para sua conta podem ser geradas no perfil do
          aplicativo
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>
          Seu app deve acessar o URL
          https://urbmobilidade.com.br / integration / auth / 
          <b>{REFERENCIA_EXTERNA}</b> / <b>{CHAVE_PUBLICA_SOLICITADOR}</b> /
          <b>{base64(URL_CALLBACK)}</b> para solicitar as chaves de API de outro
          usuário. Após o login o usuário é redirecionado para
          <b>URL_CALLBACK</b> ?external= <b>{REFERENCIA_EXTERNA}</b> &key=
          <b>{CHAVE_PUBLICA_USUARIO}</b> &key_secret=
          <b>{CHAVE_SECRETA_USUARIO}</b>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>
          <b>Guarde as chaves de API dos usuários em um local seguro</b>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>Formulário para visualização do procedimento</h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        Informe a chave pública de API do solicitador
      </div>
    </div>
    <div id="public_key_auth" class="row justify-content-md-center">
      <div class="col-md-auto">
        <input
          v-model="public_key_auth"
          type="text"
          id="input_public_key"
          class="form-control"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        Informe a url de callback
      </div>
    </div>
    <div id="callback_auth" class="row justify-content-md-center">
      <div class="col-md-auto">
        <input
          v-model="callback_auth"
          type="url"
          id="input_callback"
          class="form-control"
        />
      </div>
    </div>
    <div class="row">
      <div class="col">
        Referência externa
      </div>
    </div>
    <div id="external_auth" class="row justify-content-md-center">
      <div class="col-md-auto">
        <input
          v-model="external_auth"
          type="text"
          id="input_external"
          class="form-control"
        />
      </div>
    </div>
    <div id="button_push" class="row">
      <div class="col">
        <button
          type="button"
          class="btn btn-dark"
          :disabled="
            public_key_auth.length < 10 ||
              !validateURL(callback_auth) ||
              external_auth.length < 1
          "
          v-on:click="pushToAuth"
        >
          Ir para Login
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { validateURL } from "../static.js";

export default {
  name: "Main",
  data() {
    return {
      public_key_auth: "",
      callback_auth: "",
      external_auth: "",
    };
  },
  methods: {
    validateURL,
    pushToAuth() {
      let public_key = this.public_key_auth;
      let external = this.external_auth;

      var b = new Buffer.from(this.callback_auth);
      let url = b.toString("base64");

      if (public_key.length >= 10 && this.validateURL(this.callback_auth)) {
        this.$router.push({
          path: "/auth/" + external + "/" + public_key + "/" + url,
        });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#public_key_auth {
  margin-bottom: 20px;
}

#button_push {
  margin-top: 20px;
}

#callback_auth {
  margin-bottom: 20px;
}
</style>
